<template>
  <vx-card
    class="my-4 md:my-8 cursor-pointer"
    v-if="assignment.users && assignment.users.length > 0"
  >
    <vs-row
      class="flex-col md:flex-row"
      @click.native="routeToReviewPage(assignment.itemId)"
      ><vs-col class="md:w-1/3 lg:w-1/6"
        ><div class="overflow-hidden rounded-lg assignment__img">
          <img
            class="h-full w-full object-cover"
            :src="
              assignment.feedLibraryItem.imageUrl
                ? assignment.feedLibraryItem.imageUrl
                : randomFeedImage
            "
            :alt="assignment.feedLibraryItem.title"
            @error="randomFeedImage"
          /></div></vs-col
      ><vs-col class="md:w-2/3 lg:w-5/6 md:pl-8 flex flex-col justify-between">
        <div>
          <div
            class="flex items-center mt-2 lg:mt-0"
            v-if="
              assignment.users[0] &&
              assignment.users[0].assignedFromGtbrddUserId
            "
          >
            <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
              <img
                class="w-full h-full object-cover rounded-full"
                :src="
                  userProfilePic
                    ? constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      userProfilePic
                    : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        userName,
                        userName
                      )}`
                "
              />
            </div>
            <div class="font-semibold text-lg text-black">
              Assigned By {{ userName }}
              {{
                getAssignedUser(assignment.users[0].assignedFromGtbrddUserId)
              }}
            </div>
          </div>
          <div
            class="flex items-center mt-2 lg:mt-0"
            v-else-if="assignment.feedLibraryItem.assignedBy.type === 'user'"
          >
            <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
              <img
                class="w-full h-full object-cover rounded-full"
                :src="
                  userProfilePic
                    ? constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      userProfilePic
                    : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        userName,
                        userName
                      )}`
                "
              />
            </div>
            <div class="font-semibold text-lg text-black">
              Assigned By {{ userName }}
              {{ getAssignedUser(assignment.feedLibraryItem.assignedBy._id) }}
            </div>
          </div>
          <div v-else></div>
          <div class="flex items-center">
            <div
              class="text-black text-2xl truncate grow mt-2 lg:mt-0"
              v-if="
                assignment.feedLibraryItem && assignment.feedLibraryItem.title
              "
            >
              {{ assignment.feedLibraryItem.title }}
            </div>

            <img
              @click.stop="openLink(assignment.feedLibraryItem)"
              class="ml-3 mt-2 lg:mt-0 cursor-pointer"
              src="@/assets/images/icons/arrow-right-circle.svg"
              alt="right-arrow"
            />
          </div>

          <div
            class="text-lg gray-400 my-3 clip-text"
            v-if="
              assignment.feedLibraryItem &&
              assignment.feedLibraryItem.description &&
              typeof assignment.feedLibraryItem.description === 'string'
            "
          >
            {{ assignment.feedLibraryItem.description }}
          </div>

          <div
            class="text-lg gray-400 my-3"
            v-else-if="assignment.feedLibraryItem.description.length > 0"
          >
            <div
              v-for="(data, index) in assignment.feedLibraryItem.description"
              :key="index"
              v-html="data"
            ></div>
          </div>
        </div>

        <vs-row
          class="flex-col flex-col-reverse md:flex-row md:items-center justify-between"
        >
          <vs-row
            class="items-center"
            :class="
              assignment.libraryItemValidationData.validationType
                ? 'max-w-sm'
                : 'w-1/2'
            "
            style="width: fit-content"
            v-if="
              assignment &&
              assignment.libraryItemValidationData &&
              assignment.libraryItemValidationData.validationType
            "
          >
            <div
              class="button__validate p-2 rounded-full"
              @click="addValidation()"
            >
              <img
                v-if="
                  assignment.libraryItemValidationData.validationType ===
                  'attendance'
                "
                src="@/assets/images/icons/qr.svg"
                class="w-6 h-6"
                alt=""
              />

              <img
                v-else-if="
                  assignment.libraryItemValidationData.validationType === 'quiz'
                "
                src="@/assets/images/icons/quiz.svg"
                class="w-6 h-6"
                alt=""
              />

              <img
                v-else-if="
                  assignment.libraryItemValidationData.validationType ===
                  'upload'
                "
                src="@/assets/images/icons/upload.svg"
                class="w-6 h-6"
                alt=""
              />
            </div>
            <!-- <vs-button
              class="button__validate px-3 py-2"
              @click.native="routeToReviewPage(assignment.itemId)"
              >Validate</vs-button
            > -->
            <!-- <div
              v-if="
                assignment.libraryItemValidationData.xpValue &&
                !assignment.libraryItemValidationData.tokens
              "
              class="ml-2 gray-500 font-semibold"
            >
              {{ assignment.libraryItemValidationData.xpValue
              }}<span class="ml-1">XP</span>
            </div> -->

            <div v-if="xp" class="ml-2 gray-500 font-semibold">
              {{ xp }}<span class="ml-1">XP</span>
            </div>
            <div v-if="gold" class="ml-2 gray-500 font-semibold">
              {{ gold }}<span class="ml-1">Gold</span>
            </div>
          </vs-row>

          <vs-tooltip
            v-else
            class="cursor-pointer"
            text="Associate a validation type with this course to confirm the learning. "
          >
            <div class="button__submit-validation p-2 rounded-full">
              <img
                @click="addValidation()"
                src="@/assets/images/icons/add-circle.svg"
                class="w-6 h-6"
                alt=""
              />
            </div>
          </vs-tooltip>

          <!-- <vs-button
            v-else
            class="button__add-validation px-3 py-2"
            @click.native="addValidation()"
            >Add validation</vs-button
          > -->
          <div
            class="mb-2 md:mb-0 flex"
            v-if="assignment && usersArray && usersArray.length > 0"
          >
            <div
              @click.stop
              v-for="(user, i) in usersArray.slice(0, 5)"
              :key="i"
            >
              <vx-tooltip
                class="capitalize"
                :text="`${user.userData.firstName} ${user.userData.lastName}`"
              >
                <vs-avatar
                  @click="toggleUnassignCoursePrompt(user.userData, i)"
                  :style="borderStyle(user, user.feedItemUserValidationStatus)"
                  size="37px"
                  class="m-1 w-100 z-10"
                  v-if="
                    user && user.userData && user.userData.profilePictureUrl
                  "
                  :src="`${constants.s3Bucket}/editor/profile-pictures/${user.userData.profilePictureUrl}`"
                />
                <vs-avatar
                  @click="toggleUnassignCoursePrompt(user.userData, i)"
                  :style="borderStyle(user, user.feedItemUserValidationStatus)"
                  v-else
                  size="37px"
                  class="m-1"
                  :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                    user.userData.firstName || 'boringAvatar',
                    user.userData.lastName || 'boringAvatar'
                  )}`"
                />
              </vx-tooltip>
            </div>

            <div @click.stop v-if="usersArray.length > 5">
              <vs-dropdown vs-trigger-click :color="orgColor">
                <vx-tooltip :text="`${usersArray.length - 5} others`">
                  <vs-avatar
                    @click.native="stopRouting"
                    size="37px"
                    class="cursor-pointer"
                    :text="`+${usersArray.length - 5}`"
                  />
                </vx-tooltip>

                <vs-dropdown-menu>
                  <vs-input
                    class="m-2"
                    id="vs--input"
                    :color="`${orgColor}`"
                    icon-no-border
                    icon="search"
                    icon-size="large"
                    placeholder="Search User"
                    v-model="searchValue"
                    v-on:input="searchUser()"
                    style="width: auto"
                  />
                  <vs-dropdown-item
                    class="mt-0 cursor-pointer"
                    v-for="(user, index) in searchedUserArray"
                    :key="index"
                    @click="toggleUnassignCoursePrompt(user.userData, index)"
                  >
                    <vs-avatar
                      v-if="
                        user && user.userData && user.userData.profilePictureUrl
                      "
                      size="40px"
                      class="-m-1 mr-2"
                      @click="toggleUnassignCoursePrompt(user.userData, index)"
                      :src="
                        constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        user.userData.profilePictureUrl
                      "
                    />
                    <vs-avatar
                      v-else-if="
                        user &&
                        user.userData &&
                        !user.userData.profilePictureUrl
                      "
                      size="40px"
                      @click="toggleUnassignCoursePrompt(user.userData, index)"
                      class="-m-1 mr-2"
                      :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        user.userData.firstName,
                        user.userData.lastName
                      )}`"
                    />
                    <p class="text-lg">
                      {{ user && user.userData ? user.userData.firstName : "" }}
                      {{ user && user.userData ? user.userData.lastName : "" }}
                    </p>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </vs-row>
      </vs-col></vs-row
    >

    <!-- <vs-prompt
      title=""
      @close="validatePrompt = false"
      :active="validatePrompt"
      buttons-hidden
    >
      <vs-row class="text-xl font-semibold text-black border-4"
        >Assign XP</vs-row
      >
      <vs-input
        class="w-full mt-3"
        v-model="xpValue"
        @keypress="handleInputChange"
      />
      <h5 class="text-danger my-2" v-if="wrongValue && xpValue">
        Please enter a proper value
      </h5>

      <h5 class="text-danger my-2" v-if="recommendedValue">
        Recommended {{ xpValue }} XP's
      </h5>

      <vs-row class="text-xl font-semibold text-black border-4 mt-4"
        >Validation</vs-row
      >
      <div class="flex flex-wrap -m-1 mt-3">
        <div
          v-for="(option, i) in validationOptions"
          :key="i"
          @click="
            selectedOption === option.id
              ? (selectedOption = '')
              : (selectedOption = option.id)
          "
          class="validation-option px-4 py-2 flex items-center m-1 cursor-pointer"
          :class="
            selectedOption === option.id ? 'validation-option-selected' : ''
          "
        >
          <img
            :src="require(`@/assets/images/icons/org-review/${option.id}.svg`)"
            :alt="option.title"
          />
          <h5 class="ml-2 font-semibold">{{ option.title }}</h5>
        </div>
      </div>

      <hr class="my-5" />

      <vs-button
        class="button__submit-validation px-3 py-2 float-right text-black text-xl mb-4 font-semibold"
        :class="
          !this.selectedOption || !this.xpValue || wrongValue
            ? 'opacity-50 pointer-events-none'
            : ''
        "
        @click.native="submitValidation(assignment.itemId)"
        >Submit</vs-button
      >
    </vs-prompt> -->

    <!-- <vs-prompt
      v-if="qrCode"
      title=""
      @close="qrCodePrompt = false"
      :active="qrCodePrompt"
      buttons-hidden
    >
      <div class="w-full h-full flex flex-col items-center justify-center">
        <div class="w-32 h-32 lg:w-64 lg:h-64">
          <img :src="qrCode" class="w-full h-full object-cover" :alt="qrCode" />
        </div>
        <vs-tooltip text="Download QR Code" position="top">
          <div @click="downloadQrCode" class="flex mt-2 p-2 icon-border">
            <feather-icon
              icon="DownloadIcon"
              style="
                 {
                  color: #667085;
                }
              "
            />
          </div>
        </vs-tooltip>
      </div>
    </vs-prompt> -->

    <!-- Course popup  -->
    <vs-prompt
      title=""
      @close="unassignCoursePrompt = false"
      :active="unassignCoursePrompt"
      buttons-hidden
    >
      <div data-v-7c4d3b3e="" class="text-gray-700 text-lg">
        The course is currently assigned to
        {{ selectedUser.firstName }}
        {{ selectedUser.lastName ? selectedUser.lastName : "" }}. You want to
      </div>
      <div class="flex justify-end items-center mt-6 gap-2">
        <vs-tooltip class="cursor-pointer" text="View Progress">
          <vs-button
            color="#F2C244"
            class="px-4 font-semibold"
            @click="routeToReviewPage(assignment.itemId, selectedUser)"
            >View</vs-button
          >
        </vs-tooltip>
        <vs-tooltip class="cursor-pointer" text="Unassign Course">
          <div class="p-2 rounded-full flex">
            <img
              @click="unassignCourse"
              src="@/assets/images/icons/minus-circle.svg"
              class="w-8 h-8"
              alt="Unassign Course"
            />
          </div>
        </vs-tooltip>
        <!-- <vs-button
          color="#FB2E56"
          class="px-4 font-semibold"
          @click="unassignCourse"
          >Unassign Course</vs-button
        > -->
      </div>
    </vs-prompt>
  </vx-card>
</template>

<script>
import constants from "@/constants";
import QRCode from "qrcode";

export default {
  data() {
    return {
      constants,
      validatePrompt: false,

      routeToLink: false,
      // validationOptions: [
      //   {
      //     id: "upload",
      //     title: "Upload",
      //   },
      //   // {
      //   //   id: "quiz",
      //   //   title: "Quiz",
      //   // },
      // ],
      selectedOption: "",
      xpValue: "",
      wrongValue: false,
      recommendedValue: true,
      userName: "",
      userProfilePic: "",
      xp: 0,
      gold: 0,
      qrCodePrompt: false,
      qrCode: "",
      searchedUserArray: [],
      searchValue: "",
      usersArray: [],
      unassignCoursePrompt: false,
      selectedUser: {},
    };
  },
  props: {
    assignment: {
      type: Object,
      required: true,
    },
    orgId: {
      type: String,
      required: true,
    },
    orgColor: {
      type: String,
      // required: true,
    },
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  watch: {
    xpValue(newVal) {
      if (Number.isInteger(parseInt(newVal)) && newVal > -1) {
        this.wrongValue = false;
      } else {
        this.wrongValue = true;
      }
    },
    assignment: {
      handler(newVal) {
        this.usersArray = newVal.users;
        this.searchedUserArray = newVal.users;
        this.xpValue = newVal.feedLibraryItem.knowledgeToken;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (
      this.assignment.libraryItemValidationData &&
      this.assignment.libraryItemValidationData.tokens
    ) {
      this.getToken(this.assignment.libraryItemValidationData.tokens);
    }
  },
  methods: {
    addValidation() {
      event.stopPropagation();
      this.$store.commit("modals/OPEN_ADD_VALIDATION_POPUP", true);
      this.$emit("assignmentToValidate", this.assignment);
      this.routeToLink = false;
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    openLink(item) {
      this.routeToLink = true;
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.orgId
      }&redirectsourceid=ORG_REVIEW`;
      if (link && this.routeToLink) {
        window.open(link, "_blank");
        this.routeToLink = false;
      }
    },
    stopRouting() {
      event.stopPropagation();
      this.routeToLink = false;
    },
    openUserItems(userData) {
      this.stopRouting();
      this.$router.push({
        name: "single-user-org-assignment-review",
        query: { userId: userData._id },
      });
    },
    borderStyle(user, isValidation) {
      let status = user.feedLibraryItemStatus;
      let borderColor;
      if (status === "done") {
        if (isValidation) {
          borderColor = "#12B76A";
        } else {
          borderColor = "#F2C046";
        }
      } else if (status === "doing") {
        borderColor = "#F2C046";
      } else {
        borderColor = "red";
      }
      return {
        border: `3px solid ${borderColor}`,
      };
    },
    submitValidation(itemId) {
      const payload = {
        gtbrddOrganizationId: this.orgId,
        feedItemId: itemId,
        validationType: this.selectedOption,
        xpValue: this.xpValue,
      };

      this.$store
        .dispatch("alex/assignValidation", payload)
        .then(() => {
          this.$store.commit("modals/OPEN_ADD_VALIDATION_POPUP", false);
          this.assignment["libraryItemValidationData"] = payload;
        })
        .catch(() => {});
    },
    routeToReviewPage(itemId, userData) {
      this.stopRouting();
      if (userData) {
        this.$router.push({
          name: "org-assignment-review",
          params: { itemId: itemId },
          query: { user: userData.activeIndex, uid: userData._id },
        });
      } else {
        this.$router.push({
          name: "org-assignment-review",
          params: { itemId: itemId },
        });
      }
    },
    handleInputChange(event) {
      if (event && event.target && event.target.value) {
        this.recommendedValue = false;
      }
    },
    getAssignedUser(id) {
      this.$store
        .dispatch("users/getAssignedUser", id)
        .then((res) => {
          this.userProfilePic = res.profilePictureUrl
            ? res.profilePictureUrl
            : "";
          if (
            res.firstName === this.userData.firstName &&
            res.lastName === this.userData.lastName
          ) {
            this.userName = "you";
          } else {
            this.userName = `${res.firstName} ${
              res.lastName ? res.lastName : ""
            }`;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getToken(tokens) {
      if (tokens) {
        for (let i = 0; i < tokens.length; i++) {
          if (tokens[i].key === 0) {
            this.xp = tokens[i].value;
          } else if (tokens[i].key === 6) {
            this.gold = tokens[i].value;
          }
        }
      }
    },
    searchUser() {
      if (this.searchValue) {
        this.searchedUserArray = this.usersArray.filter((user) => {
          if (user.userData.firstName && user.userData.lastName) {
            return (
              user.userData.firstName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase()) ||
              user.userData.lastName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            );
          } else if (user.userData.firstName) {
            return user.userData.firstName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          } else if (user.userData.lastName) {
            return user.userData.lastName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          }
        });
        return;
      } else {
        return (this.searchedUserArray = this.usersArray);
      }
    },
    toggleUnassignCoursePrompt(user, index) {
      this.selectedUser = user;
      this.selectedUser.activeIndex = index;
      this.unassignCoursePrompt = true;
    },
    unassignCourse() {
      const payload = {
        gtbrddUserId: this.selectedUser._id,
        gtbrddOrganizationId: this.orgId,
        feedItemId: this.assignment.itemId,
      };
      this.$store
        .dispatch("alex/unassignCourse", payload)
        .then((res) => {
          if (res) {
            let userIndex = this.usersArray.findIndex(
              (user) => user.userData._id === this.selectedUser._id
            );
            if (userIndex > -1) {
              this.usersArray.splice(userIndex, 1);
            }

            this.$vs.notify({
              text: `The task has been successfully unassigned from ${
                this.selectedUser.firstName
              }
       ${this.selectedUser.lastName ? this.selectedUser.lastName : ""}`,
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
              fixed: false,
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            text: "Please try again later",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });
        })
        .finally(() => {
          this.unassignCoursePrompt = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  &__validate {
    background: #12b76a !important;
  }
  &__add-validation {
    background: #f04438 !important;
  }
  &__submit-validation,
  &--add {
    background: #ffce42 !important;
  }
}

.assignment {
  &__img {
    height: 14em;
  }
}
.gray {
  &-400 {
    color: #798ba0;
  }
  &-500 {
    color: #667085;
  }
}

.validation-option {
  width: fit-content;
  border-radius: 2em;
  border: 1px solid #dfe3eb;
  img {
    filter: invert(64%) sepia(10%) saturate(485%) hue-rotate(179deg)
      brightness(101%) contrast(84%);
  }
  &-selected {
    background: #0ba5ec;
    border: none;
    h5 {
      color: #ffffff;
    }
    img {
      filter: none;
    }
  }
}

.con-vs-avatar ::v-deep .vs-avatar--text {
  font-size: 1.5rem;
}

.vs-input ::v-deep .vs-input--input {
  background: #ffffff;
  border: 1px solid #dfdfdf !important;
  border-radius: 2em;
  font-size: 1.25em;
}

.clip-text {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  &--2 {
    -webkit-line-clamp: 2;
  }
}

.icon-border {
  cursor: pointer;
  border-radius: 0.5rem;
  border: 2px solid #d0d5dd;
}
</style>

<style scoped>
.vs-dropdown--item >>> .vs-dropdown--item-link {
  display: flex;
  align-items: center;
  margin: 0.5em 0;
  padding-left: 1em;
  padding-right: 2em;
}

.con-vs-dropdown--menu {
  max-height: 17.5em;
  width: max-content;
  height: auto !important;
  overflow-y: scroll;
}

.con-vs-dropdown--menu::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.con-vs-dropdown--menu::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(128, 128, 128, 0.378);
  /* border-radius: 10px; */
}

/* Handle */
.con-vs-dropdown--menu::-webkit-scrollbar-thumb {
  background: rgba(199, 195, 195, 0.658);
  border-radius: 10px;
}

.vs-input >>> .vs-input--icon {
  font-size: 1.5rem;
  color: #97a4bf !important;
}
</style>
